import { format } from 'date-fns';

export const formatTimestamp = (timestamp?: string): string => {
    return format(Number(timestamp || '0'), 'yyyy-MM-dd');
};
